function Servicios() {
    return (
        <section className="servicios" id="servicios">
            <div className="wrap">
                <div className="servicios-card">
                    <div className="sec-title">
                        <h2>Servicios</h2>
                        <div className="bar"></div>
                    </div>

                    <div className="serv-grid">

                        {/* SERVICIO 1 */}
                        <div className="serv-card" id="serv-certificada">
                            <div className="serv-head">
                                <div className="ic"><i className="fas fa-stamp"></i></div>
                                <h3>Traducción Certificada (CTP)</h3>
                            </div>

                            <div className="only-desk">
                                <ul>
                                    <li>Se realiza por un traductor colegiado y habilitado por el Colegio de Traductores del Perú (CTP)</li>
                                    <li>Tiene validez legal dentro de Perú y en el exterior. Cuenta con firma y sello del traductor colegiado</li>
                                    <li>Forma de entrega: En físico y/o digital</li>
                                </ul>

                                <p className="lbl">Documentos:</p>
                                <p className="small">
                                    Partidas de nacimiento, Actas de matrimonio, Certificados policiales, judiciales y penales, Constancias de estudio, etc.
                                </p>
                                <p className="small">
                                    Contratos, partidas registrales, extractos bancarios.
                                </p>
                            </div>

                            <ul className="only-mob">
                                <li>Válida en Perú y el extranjero</li>
                                <li>Firma y sello oficial</li>
                                <li>Entrega digital o física</li>
                            </ul>

                            <a className="btn btn-outline serv-more" href="servicios/traduccion-certificada/">
                                Más información
                            </a>
                        </div>

                        {/* SERVICIO 2 */}
                        <div className="serv-card" id="serv-no-certificada">
                            <div className="serv-head">
                                <div className="ic"><i className="fas fa-file-lines"></i></div>
                                <h3>Traducción no certificada</h3>
                            </div>

                            <div className="only-desk">
                                <ul>
                                    <li>Se realiza por un traductor profesional con experiencia</li>
                                    <li>No tiene validez legal ni firma del traductor colegiado</li>
                                </ul>

                                <p className="small">
                                    Incluye CV, investigaciones, páginas web, informes, etc.
                                </p>
                            </div>

                            <ul className="only-mob">
                                <li>Traducción profesional</li>
                                <li>Contenido empresarial</li>
                                <li>CV</li>
                                <li>Páginas web</li>
                                <li>Informes</li>
                            </ul>

                            <a className="btn btn-outline serv-more" href="servicios/traduccion-simple/">
                                Más información
                            </a>
                        </div>

                        {/* SERVICIO 3 */}
                        <div className="serv-card" id="serv-especializada">
                            <div className="serv-head">
                                <div className="ic"><i className="far fa-star"></i></div>
                                <h3>Traducción especializada</h3>
                            </div>

                            <div className="only-desk">
                                <p className="small">Áreas:</p>
                                <ul>
                                    <li>Ingeniería</li>
                                    <li>Construcción</li>
                                    <li>Minería</li>
                                    <li>Seguridad y Salud Ocupacional</li>
                                    <li>Medioambiente</li>
                                    <li>Energía</li>
                                    <li>Petróleo y Gas</li>
                                    <li>Legal corporativo</li>
                                </ul>

                                <p className="small">
                                    Contamos con especialistas por área para precisión terminológica.
                                </p>
                            </div>

                            <ul className="only-mob">
                                <li>Ingeniería</li>
                                <li>Minería</li>
                                <li>Construcción</li>
                                <li>Seguridad y Salud</li>
                                <li>Energía</li>
                                <li>Legal</li>
                            </ul>

                            <a className="btn btn-outline serv-more" href="servicios/traduccion-especializada/">
                                Más información
                            </a>
                        </div>

                    </div>
                </div>

                {/* INTERPRETACIÓN + OTROS */}
                <div className="interp">

                    {/* DESKTOP */}
                    <div id="interpretacion" className="interp-main">

                        <div className="only-desk interp-desk">
                            <div className="ic"><i className="fas fa-user-group"></i></div>

                            <div className="interp-txt">
                                <h3>Interpretación</h3>

                                <p><span className="lbl">Simultánea:</span> Traducción en tiempo real.</p>
                                <p><span className="lbl">Consecutiva:</span> Traducción después del orador.</p>
                                <p><span className="lbl">Enlace:</span> Comunicación entre grupos pequeños.</p>
                            </div>
                        </div>

                        {/* MOBILE */}
                        <div className="only-mob">
                            <h3><i className="fas fa-user-group"></i> Interpretación</h3>

                            <div className="interp-types">
                                <div className="itype">
                                    <div className="itype-head">
                                        <i className="fas fa-tower-broadcast"></i>
                                        <b>Simultánea</b>
                                    </div>
                                    <p>Tiempo real.</p>
                                </div>

                                <div className="itype">
                                    <div className="itype-head">
                                        <i className="fas fa-comments"></i>
                                        <b>Consecutiva</b>
                                    </div>
                                    <p>Después del orador.</p>
                                </div>

                                <div className="itype">
                                    <div className="itype-head">
                                        <i className="fas fa-handshake"></i>
                                        <b>Enlace</b>
                                    </div>
                                    <p>Grupos pequeños.</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* OTROS SERVICIOS */}
                    <div id="otros-servicios" className="otros-main">
                        <h3>Otros servicios</h3>

                        <ul className="list2">
                            <li><i className="far fa-circle-check"></i> Revisión y edición de textos</li>
                            <li><i className="far fa-circle-check"></i> Localización de textos</li>
                        </ul>

                        <div className="otros-illu">
                            <i className="fas fa-file-pen"></i>
                        </div>
                    </div>

                </div>
            </div>
        </section>
    );
}

export default Servicios;